"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var react_1 = require("react");
var React = require("react");
require("font-awesome/css/font-awesome.min.css");
var react_intl_1 = require("react-intl");
var react_router_dom_1 = require("react-router-dom");
var LanguageLink_1 = require("./LanguageLink");
var vplogo = require('../panchayatGuruLogo.svg');
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 50px;\n    width: 100%;\n    background: #004269;\n    display:flex;\n    margin-bottom:2px;\n"], ["\n    height: 50px;\n    width: 100%;\n    background: #004269;\n    display:flex;\n    margin-bottom:2px;\n"])));
var InnerContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 50px;\n    width: 95%;\n    background: transparent;\n    display:flex;\n    font-size :'25px' !important;\n    margin:'10px'!important;\n    float:left\n"], ["\n    height: 50px;\n    width: 95%;\n    background: transparent;\n    display:flex;\n    font-size :'25px' !important;\n    margin:'10px'!important;\n    float:left\n"])));
var LinksContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 50px;\n    width: 10%;\n    background: transparent;\n    display:flex;\n    float:right\n"], ["\n    height: 50px;\n    width: 10%;\n    background: transparent;\n    display:flex;\n    float:right\n"])));
var Title = styled_components_1.default.a(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: white !important;\n    margin: 0;\n    padding:12px;\n    text-align: left;\n    font-size: 20px;\n    display: inline-block;\n"], ["\n    color: white !important;\n    margin: 0;\n    padding:12px;\n    text-align: left;\n    font-size: 20px;\n    display: inline-block;\n"])));
var StyledLanguageLink = styled_components_1.default(LanguageLink_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\ncolor: white !important;\nmargin: 2px;\npadding-top: 7px;\npadding-right:15px;\ntext-align: right;\nfont-size: 16px;\ndisplay: inline-block;\n"], ["\ncolor: white !important;\nmargin: 2px;\npadding-top: 7px;\npadding-right:15px;\ntext-align: right;\nfont-size: 16px;\ndisplay: inline-block;\n"])));
var CommonHeader = function (props) {
    var _a = react_1.useState(false), dropdownOpen = _a[0], setDropdownOpen = _a[1];
    var _b = react_1.useState(false), isLanguageRequire = _b[0], setisLanguageRequire = _b[1];
    var handleClick = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            props.history.push('/' + type);
            return [2 /*return*/];
        });
    }); };
    return React.createElement(Container, { className: "col-md-12" },
        React.createElement(InnerContainer, null,
            React.createElement("div", null,
                React.createElement("a", { onClick: function () { return handleClick(''); }, style: { height: '100%', margin: '10px', display: 'inline-block', color: '#fff' } }, "Info Apps"))),
        isLanguageRequire ? React.createElement(LinksContainer, null,
            React.createElement(StyledLanguageLink, __assign({}, props, { setLanguage: props.setLanguage }))) : '');
};
exports.default = react_intl_1.injectIntl(react_router_dom_1.withRouter(CommonHeader));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=CommonHeader.js.map